import { render, staticRenderFns } from "./SitchBackButton.vue?vue&type=template&id=1a05229e&scoped=true&"
import script from "./SitchBackButton.vue?vue&type=script&lang=ts&"
export * from "./SitchBackButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a05229e",
  null
  
)

export default component.exports